var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 65,
    viewBox: "0 0 31 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7229_60636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8732 50.2595L24.1349 33.5188L25.1725 22.1212C25.4287 19.2374 23.11 16.7656 20.138 16.7656H10.8631C7.89105 16.7656 5.55952 19.2499 5.82855 22.1212L6.8662 33.5188L0.115025 50.2595C-0.307725 51.3081 0.486531 52.4442 1.65229 52.4442H8.57001L9.37708 61.3076C9.55642 63.2676 11.2346 64.7656 13.2587 64.7656H17.7424C19.7665 64.7656 21.4446 63.2551 21.624 61.2951L22.4311 52.4442H29.3488C30.5017 52.4442 31.3088 51.3081 30.886 50.2595H30.8732Z",
    fill: "url(#paint0_linear_7229_60636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 7.76562C22 11.6413 18.8625 14.7656 15 14.7656C11.1375 14.7656 8 11.6281 8 7.76562C8 3.9031 11.1243 0.765625 14.9868 0.765625C18.8493 0.765625 21.9868 3.9031 21.9868 7.76562H22Z",
    fill: "url(#paint1_linear_7229_60636)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7229_60636",
    x1: -3.26697,
    y1: 7.60256,
    x2: 28.082,
    y2: 66.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E074AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F0577F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7229_60636",
    x1: 10.4783,
    y1: -0.486729,
    x2: 44.0414,
    y2: 60.8523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E074AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F0577F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7229_60636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 64,
    fill: "white",
    transform: "translate(0 0.765625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/femaleIcon.f186eb26787b441cff6ec863781621f0.svg";
export { ForwardRef as ReactComponent };